const HOW_TO = 'how-to';
const SEARCH = 'search';
const LEGACY = 'legacy'

const createURL = (splitPath, permalink, productInfo = null) => {
  const productHasVersioning = productInfo && productInfo.versions
  const productHasAppTypes = productInfo && productInfo.apptypes
  const pathPart = productHasVersioning || productHasAppTypes || (splitPath[0] === 'how-to' && splitPath.length >= 3) ? `${splitPath[0]}/${splitPath[1]}` : splitPath[0]
  return `${pathPart}/${permalink}`
}

const getBasePath = (path) => {
  const sliceIndex = path.indexOf('/', 1);
  let basePath = HOW_TO
  if (path === '/search/') {
    basePath = SEARCH
  } else if (path !== '/') {
    basePath = sliceIndex > 0 ? path.slice(1, sliceIndex) : path.slice(1, path.length);
  }
  return basePath
}

module.exports = {
  createURL,
  getBasePath,
  HOW_TO,
  SEARCH,
  LEGACY
}
